import React from "react";
import styles from "./Footer.module.less";
import buttonStyles from "../Button/Button.module.less";
import { Link } from "react-router-dom";

export interface Props {}

export default function Footer(props: Props) {
    return (
        <footer className={styles.Footer}>
            <Link to="/">
                <img
                    src={process.env.PUBLIC_URL + "/assets/Business_Sweden_logo_white.svg"}
                    alt="Logo"
                    height="60"
                    width="102"
                />
            </Link>

            <p>
                <a
                    className={[buttonStyles.Button, buttonStyles["Button--small"]].join(" ")}
                    href="https://business-sweden.com"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Go to business-sweden.com
                </a>
            </p>
            <p className={styles["Footer-copyright"]}>© Business Sweden. All Rights Reserved</p>
        </footer>
    );
}
